import DateFormat from "../common/dateFormat/DateFormat";

const INITIAL_STATE = {
	aguardando: false,
	registro: {},
	filtro: {
		id_status: 1,
		periodo: 'data_base',
		data: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	},
	modoTela: 'lista',
	lista: [],
	listaOperacao: [],
	listaComissaoTermo: [],
	listaComissaoVinculo: [],
	listaUsuario: [],
	listaComissaoTipo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'COMISSAO_OPERACAO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'COMISSAO_OPERACAO_SET_AGUARDANDO':
            return { ...state,
				aguardando: action.payload
			};

		case 'COMISSAO_OPERACAO_FILTRO':
            return {
				...state,
				filtro: action.payload.filtro
			};

        case 'COMISSAO_OPERACAO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'COMISSAO_OPERACAO_OPERACAO_SELECT_LISTADO':
		return {
			...state,
			listaOperacao: action.payload.data.map(item => ({ 
				...item, 
				valor: `${item.codigo} - ${item.valor}`, 
				nome: item.valor,
				id_operacao: item.id,
				codigo_operacao: item.codigo,
				nome_operacao: item.valor,
				registroOperacao: true
			}))
		};

		case 'COMISSAO_OPERACAO_TERMO_SELECT_LISTADO':
		return {
			...state,
			listaComissaoTermo: action.payload.data
		};

		case 'COMISSAO_OPERACAO_VINCULO_SELECT_LISTADO':
		return {
			...state,
			listaComissaoVinculo: action.payload.data
		};

		case 'COMISSAO_OPERACAO_USUARIO_SELECT_LISTADO':
		return {
			...state,
			listaUsuario: action.payload.data.filter(item => item.comissao_variavel)
		};

		case 'COMISSAO_OPERACAO_COMISSAO_SELECT_LISTADO':
		return {
			...state,
			listaComissaoTipo: action.payload.data
		};			

        default:
            return state;
    }
}
